import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { DefaultDataService } from '../default_data/default_data.service';
import { ReplaySubject, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class SettingsService implements OnDestroy {
  isSettingsUpdated: boolean;
  settingSubscription: Subscription;
  redirectSettings: ReplaySubject<any> = new ReplaySubject(1);

  constructor(
    private _defaultDataService: DefaultDataService) {
      this.isSettingsUpdated = false;
      this.redirectSettings.next(false);
  }

  updateSettingsData(): void {
    this.settingSubscription = this._defaultDataService.getDefaultdata()?.subscribe((response: any) => {
      this.isSettingsUpdated = true;
    });
  }

  ngOnDestroy(): void {
    if(this.settingSubscription){
      this.settingSubscription?.unsubscribe();
    }
  }
}
